export default [
    {
        text: 'sucursal',
        value: 'documentType',
    },
    {
        text: 'Folio',
        value: 'number',
    },
    {
        text: 'tipo',
        value: 'documentType',
    },
    {
        text: 'Total',
        value: 'total',
        format: 'currency',
    },
    /*{
        text: 'Neto',
        value: 'net_total',
        format: 'currency',
    },
    {
        text: 'IVA',
        value: 'iva',
        format: 'currency',
    },*/
    {
        text: 'emisión',
        value: 'emission_date',
        format: 'date',
    },
    {
        text: 'pago',
        value: 'realPayDate',
        format: 'date',
    },
    {
        text: 'vencimiento',
        value: 'payDate',
        format: 'date',
    },
    {
        text: 'Estado',
        value: 'status',
    },
]
